 class Message {
  text: string;
  username: string;
  bot_id: string;
  type: string;
  subtype: string;
  ts: string;
  attachments: Attachment;
 
}
 class Attachment {
   text: string;
   id: number;
   fallback: string;
}

export class Root {
  ok: boolean;
  channel: string;
  ts: string;
  message: Message;

}
